<div class="modal-header">
  <span class="pull-right">
    <button class="btn btn-default btn-xs" (click)="closeModal()">
      <i class="glyphicon glyphicon-remove"></i>
    </button>
  </span>
  <span>
    <h4 class="modal-title">{{ request.title }}</h4>
  </span>
</div>

<div class="modal-body" [formGroup]="assignmentForm">
  <div class="form-horizontal">
    <div class="form-group">
      <label class="control-label col-sm-4">Notes</label>
      <div class="col-sm-8">
        <textarea
          class="form-control"
          maxlength="2000"
          rows="20"
          formControlName="comment"
        ></textarea>
      </div>
    </div>
    <div
      class="form-group"
      [class.has-error]="assignmentForm.get('tacticalLiaison').errors"
    >
      <label class="control-label col-sm-4">Tactical Liaison</label>
      <div class="col-sm-8">
        <select class="form-control" formControlName="tacticalLiaison">
          <option [ngValue]="null"></option>
          <option *ngFor="let liaison of tacticalLiaisons" [value]="liaison.id">
            {{ liaison.givenName }} {{ liaison.surname }}
          </option>
        </select>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button
    class="btn btn-primary"
    (click)="assignRequest()"
    [disabled]="assignmentForm.invalid"
  >
    Send to CE Logistics
  </button>
</div>



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/request-assignment-modal/request-assignment-modal.component.html